var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFBAA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0833 27.7502L41.1667 23.6668M43.5 21.3335L41.1667 23.6668L43.5 21.3335ZM32.2883 32.5452C32.8907 33.1395 33.3696 33.8472 33.6974 34.6274C34.0252 35.4076 34.1954 36.245 34.1982 37.0912C34.201 37.9375 34.0365 38.776 33.7139 39.5583C33.3914 40.3407 32.9173 41.0516 32.3189 41.65C31.7205 42.2484 31.0096 42.7225 30.2272 43.0451C29.4448 43.3676 28.6063 43.5322 27.7601 43.5294C26.9138 43.5265 26.0765 43.3563 25.2963 43.0285C24.5161 42.7008 23.8084 42.2219 23.214 41.6195C22.0452 40.4093 21.3984 38.7884 21.413 37.106C21.4276 35.4236 22.1025 33.8142 23.2922 32.6245C24.4819 31.4348 26.0913 30.76 27.7737 30.7453C29.4561 30.7307 31.077 31.3775 32.2872 32.5463L32.2883 32.5452ZM32.2883 32.5452L37.0833 27.7502L32.2883 32.5452ZM37.0833 27.7502L40.5833 31.2502L44.6667 27.1668L41.1667 23.6668L37.0833 27.7502Z",
    stroke: "#BE4E40",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FFFBFA",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/FeaturedIcon.4b33ef92c575daf0068db0fc53b9e4f7.svg";
export { ForwardRef as ReactComponent };